import { useContext } from "react";
import { NutritionContext } from "../providers/nutrition-provider";

export const useNutritionPanelState = () => useContext(NutritionContext);
